import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["value"]

import { ref, withDefaults } from 'vue';
import { useTermsAndConditions } from '@/storecontext/shared/checkout/useTermsAndConditions';
import { useCheckout } from '@/storecontext/checkout/useCheckout';


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  props: {
    label: { default: 'Term' }
  },
  setup(__props: any) {



const { setSelectedTerm, basket } = useCheckout();
const { termsAndConditions } = useTermsAndConditions();

const selectedTerm = ref<number>(basket.value.termsId);

const setTerms = async() => {
    await setSelectedTerm(selectedTerm.value);
};


return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_InputSelect, {
      modelValue: selectedTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTerm).value = $event)),
      name: "termsAndConditions",
      label: __props.label,
      "show-errors": false,
      onChange: setTerms
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(termsAndConditions), (terms) => {
          return (_openBlock(), _createElementBlock("option", {
            key: terms.id,
            value: terms.id
          }, _toDisplayString(terms.title), 9, _hoisted_1))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "label"])
  ]))
}
}

})